import z from "zod";

import { pageMetadata } from "../api-types";
import { type Env } from "../http/Env";
import { graphqlRequest } from "./graphqlRequest";

export interface MutationDuplicatePageOptions {
	pageID: string;
	canvasID: string;
	title: string;
	env: Env;
	fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
	authorizationHeader: string | undefined;
}

export function mutationDuplicatePage({
	pageID,
	canvasID,
	title,
	env,
	fetch,
	authorizationHeader,
}: MutationDuplicatePageOptions): Promise<MutationDuplicatePageResponse> {
	return graphqlRequest({
		env,
		fetch,
		authorizationHeader,
		query: mutationDuplicatePageOperation(pageID, canvasID, title),
		responseSchema: mutationDuplicateResponseSchema,
	});
}

const mutationDuplicateResponseSchema = z.object({ duplicatePage: pageMetadata });
export type MutationDuplicatePageResponse = z.infer<typeof mutationDuplicateResponseSchema>;

const mutationDuplicatePageOperation = (pageID: string, canvasID: string, title: string) => ({
	operationName: "DuplicatePage",
	query: `
	mutation DuplicatePage($input: DuplicatePageInput!) {
	  duplicatePage(input: $input) {
	  	id
	  	title
		slug
		cells {
			type
			cellName
			code
			id
			nodeAttrs
		}
		authorID
		updated
		created
		canvasID
		archived
		parentPageID
	  }
	}`,
	variables: {
		input: {
			pageID,
			canvasID,
			title,
		},
	},
});
